/* ============================================================
   WOOMN — Custom JS
   Synthetic rating badges — FALLBACK ONLY.
   If a product has the custom.rating_score metafield set, the
   theme renders a real badge server-side (see card.liquid,
   [data-rb-source="metafield"]) and this script skips that card.
   Cards without a metafield badge get a seeded synthetic one.
   ============================================================ */
(function () {

  function seededRand(str) {
    var h = 5381;
    for (var i = 0; i < str.length; i++) {
      h = Math.imul(h, 31) ^ str.charCodeAt(i);
    }
    return (h >>> 0) / 4294967295;
  }

  function injectRatings() {
    document.querySelectorAll('.card__picture-container:not([data-rb])').forEach(function (container) {
      container.setAttribute('data-rb', '1');

      /* metafield badge already rendered by liquid — leave it alone */
      if (container.querySelector('.wmn-rb')) return;

      var link = container.querySelector('a[href]');
      var seed = link ? (link.pathname || link.href) : container.innerHTML.slice(0, 60);
      var rating = (3.5 + seededRand(seed) * 1.5).toFixed(1);
      var count  = Math.floor(25 + seededRand(seed + 'c') * 21);
      var badge  = document.createElement('div');
      badge.className = 'wmn-rb';
      badge.innerHTML =
        '<span class="wmn-rb__score">' + rating + '</span>' +
        '<span class="wmn-rb__star">★</span>' +
        '<span class="wmn-rb__pipe">|</span>' +
        '<span class="wmn-rb__count">' + count + '</span>';
      container.appendChild(badge);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectRatings);
  } else {
    injectRatings();
  }

  /* Re-run for dynamically added cards (filters, pagination) */
  var debounce = null;
  new MutationObserver(function (mutations) {
    var hasNew = mutations.some(function (m) {
      return Array.from(m.addedNodes).some(function (n) {
        return n.nodeType === 1 && n.querySelector &&
          n.querySelector('.card__picture-container:not([data-rb])');
      });
    });
    if (!hasNew) return;
    clearTimeout(debounce);
    debounce = setTimeout(injectRatings, 100);
  }).observe(document.body, { childList: true, subtree: true });

})();
